export const setPreference = (key: string, value: unknown): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getPreference = <T = unknown>(key: string): T | null => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export const removePreference = (key: string): void => {
  localStorage.removeItem(key);
};
